import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import LogoMark from './LogoMark'
import ThemeToggle from './ThemeToggle'

// Absolute paths (not bare "#anchor") so these work from any page, not just
// Home — Header renders on /articles and /articles/:slug too, where a bare
// "#start" is a dead link since that section doesn't exist there. Dropped the
// old "Gear" entry — it never had a destination of its own and duplicated
// "Articles" (the real archive covers Gear & Reviews-tagged pieces already).
const NAV_LINKS = [
  { href: '/#start', label: 'Start Here' },
  { href: '/#guides', label: 'Guides' },
  { href: '/articles', label: 'Articles' },
  { href: '/#about', label: 'About' },
]

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const wrapRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setMenuOpen(false)
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    document.addEventListener('click', onDocClick)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('click', onDocClick)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  return (
    <header className="hdr">
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <div className="wrap hdr-in">
        <Link className="brand" to="/" aria-label="Original Savage home">
          <LogoMark />
          <span className="bt">
            <strong>Original Savage</strong>
          </span>
        </Link>

        <nav className="nav" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hdr-right">
          <div className="menu-wrap" ref={wrapRef}>
            <button
              className="menu-btn"
              aria-label="Open navigation menu"
              aria-expanded={menuOpen}
              aria-haspopup="true"
              onClick={(e) => {
                e.stopPropagation()
                setMenuOpen((v) => !v)
              }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true">
                <path d="M3 6h18M3 12h18M3 18h18" />
              </svg>
            </button>
            <nav className="menu-panel" aria-label="Primary (mobile)" hidden={!menuOpen}>
              {NAV_LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)}>
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
          <ThemeToggle />
          <a className="btn sig" href="/#readiness">
            <span>Readiness Check</span>
          </a>
        </div>
      </div>
    </header>
  )
}
